import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 84,
    [forPhoneOnly]: {
      marginTop: 32,
    },
  },
  image: {
    width: 230,
  },
  message: {
    textAlign: 'center',
    marginTop: 48,
    marginBottom: 0,
    maxWidth: 343,
    ...typography['Lato H5'],
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
    },
  },
})
